import { render, staticRenderFns } from "./MyBreadCrumb.vue?vue&type=template&id=55bbccde&scoped=true&"
import script from "./MyBreadCrumb.vue?vue&type=script&lang=ts&"
export * from "./MyBreadCrumb.vue?vue&type=script&lang=ts&"
import style0 from "./MyBreadCrumb.vue?vue&type=style&index=0&id=55bbccde&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55bbccde",
  null
  
)

export default component.exports